<main class="min-h-screen w-full">
  <router-outlet />
</main>
